import React from 'react';
import { PbcPartner } from '../components/map/PartnerBusinessCard/PartnerData';

export interface PartnerProviderProps {
  partner: PbcPartner;
}

export interface IPartnerContext {
  partner: PbcPartner;
  partnerHasOpeningHours: boolean;
}

export const PartnerContext = React.createContext<IPartnerContext>({
  partner: {
    partnerId: '',
    officialName: '',
    address: [''],
    locationImageUrl: '',
    vCardUrl: '',
    myAudiUrl: '',
    directionsUrl: '',
    services: [''],
    nameEnhanced: '',
  },
  partnerHasOpeningHours: false,
});
